import { useEffect } from 'react';
import { initializeClarity, identifyUser, setCustomTag, trackEvent } from '@/lib/clarity';
import type { ClarityConfig } from '@/lib/clarity';

interface UseClarityOptions extends ClarityConfig {
  userId?: string;
  userRole?: string;
  userName?: string;
}

/**
 * Hook para gerenciar o Microsoft Clarity no React
 * @param options Opções de configuração do Clarity
 */
export const useClarity = (options: UseClarityOptions) => {
  useEffect(() => {
    // Inicializar o Clarity apenas se estiver habilitado e em produção ou staging
    if (options.enabled && options.projectId) {
      initializeClarity({
        projectId: options.projectId,
        enabled: options.enabled
      });

      // Identificar usuário se fornecido
      if (options.userId) {
        identifyUser(
          options.userId,
          undefined, // sessionId
          undefined, // pageId
          options.userName
        );
      }

      // Definir tags customizadas se fornecidas
      if (options.userRole) {
        setCustomTag('userRole', options.userRole);
      }

      // Marcar que o Clarity foi inicializado
      setCustomTag('clarityInitialized', 'true');
    }
  }, [options.projectId, options.enabled, options.userId, options.userRole, options.userName]);

  return {
    /**
     * Identifica um usuário
     */
    identify: (userId: string, friendlyName?: string) => {
      identifyUser(userId, undefined, undefined, friendlyName);
    },

    /**
     * Define uma tag customizada
     */
    setTag: (key: string, value: string | string[]) => {
      setCustomTag(key, value);
    },

    /**
     * Envia um evento customizado
     */
    track: (eventName: string) => {
      trackEvent(eventName);
    }
  };
};